import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Newspaper, Video, BarChart2, Calendar, Map, AlertCircle, Users, MapPin } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export default function AdminDashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)); }, []);
  if (!stats) return <div>Yükleniyor...</div>;
  const cards = [
    { k: "news", label: "Haberler", icon: Newspaper, color: "bg-blue-500" },
    { k: "videos", label: "Videolar", icon: Video, color: "bg-purple-500" },
    { k: "polls", label: "Anketler", icon: BarChart2, color: "bg-amber-500" },
    { k: "events", label: "Etkinlikler", icon: Calendar, color: "bg-emerald-500" },
    { k: "city_guide", label: "Şehir Rehberi", icon: Map, color: "bg-cyan-500" },
    { k: "users", label: "Kullanıcılar", icon: Users, color: "bg-pink-500" },
    { k: "provinces_active", label: "Aktif İl", icon: MapPin, color: "bg-[#e11d2a]" },
    { k: "pending_tips", label: "Bekleyen İhbar", icon: AlertCircle, color: "bg-orange-500" },
  ];
  return (
    <div>
      <h1 className="text-2xl font-black">Hoge geldin, {user?.first_name || user?.username} 👋</h1>
      <p className="text-gray-500 text-sm mb-6">{user?.role}</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {cards.map((c) => (
          <div key={c.k} className="bg-white border border-gray-100 rounded-lg p-5">
            <div className={`w-10 h-10 rounded-md ${c.color} text-white flex items-center justify-center mb-2`}><c.icon className="w-5 h-5" /></div>
            <div className="text-2xl font-black">{stats[c.k] ?? 0}</div>
            <div className="text-xs text-gray-500">{c.label}</div>
          </div>
        ))}
      </div>
      <div className="grid lg:grid-cols-3 gap-4 mt-6">
        <DashCard label="Bekleyen Etkinlikler" value={stats.pending_events} color="bg-emerald-50" />
        <DashCard label="Bekleyen Şehir Rehberi" value={stats.pending_city_guide} color="bg-cyan-50" />
        <DashCard label="Açık Destek Talepleri" value={stats.open_tickets} color="bg-rose-50" />
      </div>
    </div>
  );
}
const DashCard = ({ label, value, color }) => (
  <div className={`rounded-lg p-5 ${color}`}><div className="text-3xl font-black">{value || 0}</div><div className="text-sm text-gray-700">{label}</div></div>
);
